var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3168_7706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5461 10.0001C43.2371 10.0001 40.8935 11.7056 39.4173 14.5012C30.6171 31.8511 21.8047 49.2045 12.9976 66.5544C11.6688 69.1726 11.7402 72.0451 12.782 74.4247C13.8238 76.8043 16.2114 79 19.3246 79H73.7002C76.8119 79 79.1965 76.7956 80.2293 74.418C81.262 72.0403 81.3294 69.1751 79.9867 66.5679L53.1426 14.4473C51.764 11.7729 49.0876 9.98843 46.5461 10.0001ZM46.4989 30.7C47.4139 30.7 48.2913 31.0635 48.9383 31.7105C49.5853 32.3575 49.9487 33.235 49.9487 34.15V51.4472C49.9487 52.3622 49.5853 53.2397 48.9383 53.8867C48.2913 54.5337 47.4139 54.8972 46.4989 54.8972C45.5839 54.8972 44.7065 54.5337 44.0595 53.8867C43.4125 53.2397 43.049 52.3622 43.049 51.4472V34.15C43.049 33.235 43.4125 32.3575 44.0595 31.7105C44.7065 31.0635 45.5839 30.7 46.4989 30.7ZM46.4989 58.3472C47.4139 58.3472 48.2913 58.7107 48.9383 59.3577C49.5853 60.0047 49.9487 60.8822 49.9487 61.7972C49.9487 62.7122 49.5853 63.5897 48.9383 64.2367C48.2913 64.8837 47.4139 65.2472 46.4989 65.2472C45.5839 65.2472 44.7065 64.8837 44.0595 64.2367C43.4125 63.5897 43.049 62.7122 43.049 61.7972C43.049 60.8822 43.4125 60.0047 44.0595 59.3577C44.7065 58.7107 45.5839 58.3472 46.4989 58.3472Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3168_7706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4987 30.7031C47.4136 30.7031 48.2911 31.0666 48.9381 31.7136C49.5851 32.3606 49.9485 33.2381 49.9485 34.1531V51.4503C49.9485 52.3653 49.5851 53.2428 48.9381 53.8898C48.2911 54.5368 47.4136 54.9003 46.4987 54.9003C45.5837 54.9003 44.7062 54.5368 44.0593 53.8898C43.4123 53.2428 43.0488 52.3653 43.0488 51.4503V34.1531C43.0488 33.2381 43.4123 32.3606 44.0593 31.7136C44.7062 31.0666 45.5837 30.7031 46.4987 30.7031ZM46.4987 58.3503C47.4136 58.3503 48.2911 58.7137 48.9381 59.3607C49.5851 60.0077 49.9485 60.8853 49.9485 61.8003C49.9485 62.7153 49.5851 63.5928 48.9381 64.2398C48.2911 64.8868 47.4136 65.2503 46.4987 65.2503C45.5837 65.2503 44.7062 64.8868 44.0593 64.2398C43.4123 63.5928 43.0488 62.7153 43.0488 61.8003C43.0488 60.8853 43.4123 60.0077 44.0593 59.3607C44.7062 58.7137 45.5837 58.3503 46.4987 58.3503Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3168_7706",
    x: 0,
    y: 0,
    width: 93,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3168_7706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3168_7706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3168_7706",
    x: 31.0488,
    y: 20.7031,
    width: 30.8994,
    height: 58.5469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3168_7706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3168_7706",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDanger);
export default __webpack_public_path__ + "static/media/icon-danger.4c9ead3c8bb74c728a37211f681fdf90.svg";
export { ForwardRef as ReactComponent };